const prefix = 'insurancePlans';

export const FIND = `${prefix}/FIND`;
export const FETCH_VALUE = `${prefix}/FETCH_VALUE`;
